

class Owner {
    id: number;
    name: string;
}


export class FileContent {

    id?: string;
    title: string = "";
    description: string = "";
    contentType: string;
    url: string;
    date: Date;
    tags: string[];
    owner: Owner;
    repository: string;
    status: boolean;
    allows: string[];
    ancestors: string[];
    img: string;
    fileName: string;
    private_: boolean = false;
    editUsers: Owner[] = [];
    viewUsers: Owner[] = [];    
    typeOfVoting: boolean = true;
    children?: FileContent[] = [];
    likes?: number[];
    bookView: boolean = false;

}

